__turbopack_context__.v({
  "carouselContainer": "style-module-scss-module__J4KAOG__carouselContainer",
  "imageLabelContainer": "style-module-scss-module__J4KAOG__imageLabelContainer",
  "imageSlideContainer": "style-module-scss-module__J4KAOG__imageSlideContainer",
  "videoLabelContainer": "style-module-scss-module__J4KAOG__videoLabelContainer",
  "videoSlideContainer": "style-module-scss-module__J4KAOG__videoSlideContainer",
});
